<template>
  <div>
    <Navbar />
    <!-- <Breadcrumb /> -->
    <div class="card border-0 mx-auto col-md-8 col-lg-8 col-sm-12">
      <div class="card-header bg-white border-0">
        <div class="row">
          <div class="col-1">
            <div class="survey-type-badge bg-default"><fa-icon name="user" /></div>
          </div>
          <div class="col-8 align-self-center">
            Profile<br>
            <span class="small text-muted">{{user.first_name}} {{user.family_name}}</span>
          </div>
          <div class="col-2 align-self-center">
             <!--img src="Bjorn.jpg" style="height:64px;border-radius: 50%;"></img -->
          </div>
          <div class="col-1">
          </div>
        </div>
      </div>
      <div class="card-body">
        <form @submit.prevent="profile_save">
          <div class="row">
            <div class="col-12">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button 
                    class="nav-link" 
                    :class="{active: activeTab === 'contact'}"
                    type="button" 
                    @click="activeTab = 'contact'"
                  >
                    Contact Information
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button 
                    class="nav-link" 
                    :class="{active: activeTab === 'emails'}"
                    type="button" 
                    @click="activeTab = 'emails'"
                  >
                    E-mail addresses
                  </button>
                </li>
              </ul>
              <div class="tab-content mt-3">
                <div v-show="activeTab === 'contact'" class="tab-pane fade" :class="{show: activeTab === 'contact', active: activeTab === 'contact'}">
                  <div class="col-10 align-self-center ps-3" style="padding-top: 40px;">
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">First name</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="user.first_name"
                        />
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">Family name</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="user.family_name"
                        />
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">E-mail</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="user.email"
                        />
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">Company Name</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="profile.company_name"
                        />
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">Address</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control mb-2 ${anon ? 'g-anon' : '' }`" 
                          v-model="profile.address_1"
                        />
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="profile.address_2"
                        />
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">Zip Code</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="profile.zip_code"
                        />
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label class="col-form-label" style="width: 25%; flex-shrink: 0;">City</label>
                      <div style="width: 66%;">
                        <input 
                          :class="`form-control ${anon ? 'g-anon' : '' }`" 
                          v-model="profile.city"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="activeTab === 'emails'" class="tab-pane fade" :class="{show: activeTab === 'emails', active: activeTab === 'emails'}">
                  <div class="col-10 align-self-center" style="padding-top: 40px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-end">
              <button @click.prevent="profile_save()" type="submit" class="btn btn-primary">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue';  
// import Breadcrumb from './Breadcrumb.vue';  

export default {
  name: 'Profile',
  components: {
    Navbar,
    // Breadcrumb
  },
  created() {
    this.profile_get()
    this.user_get()
    this.countries_get();
  },
  data: function () {
    return {
      activeTab: 'contact',
      countries_options: [],
      profile: null,
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },

    user: {
      set() {
        return true;
      },
      get() {
        //return this.$store.state.user;
        return {
          id: this.$store.state.user.id,
          i_name: this.$store.state.user.i_name,
          i_group: this.$store.state.user.i_group,
          i_lang: this.$store.state.user.i_lang,
          family_name: this.$store.state.user.family_name,
          first_name: this.$store.state.user.first_name,
          email: this.$store.state.user.email,
        }
      }
    }
  },
  methods: {
    user_get: function() {
      this.$store.dispatch('user_fetch', { id: this.$store.state.user_id }).then((res) => {
        this.user = res.data;
      });
    },
    profile_get: function() {
      this.$store.dispatch('profile_fetch', { id: this.$store.state.user_id }).then((res) => {
        this.profile = res.data;
      });
    },
    profile_save: function() {
      this.$store.dispatch('profile_save',{
        "user": this.user,
        "profile": this.profile
      })
    },
    countries_get () {
      this.countries_options = []
      for (var i = 0; i < this.$store.state.countries.length; i++) {
        var country = {
          value: this.$store.state.countries[i].id,
          text: this.$store.state.countries[i].country_name
        }
        this.countries_options.push(country)
      }
    },
  },
}
</script>
